import React, { FC } from 'react'
import { StyledContent } from './styles'
import { Content } from '../../../components/content/Content'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

const PrivacyPolicyPage: FC = () => {
	return (
		<PublicLayout>
			<StyledContent>
				<Content slug={'privacy-policy'} />
			</StyledContent>
		</PublicLayout>
	)
}

export default PrivacyPolicyPage
